import * as actionTypes from "./actionTypes"

const initialState = {
  supportSubjectModel: false,
  donateSuccessModel: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_SUPORT_SUBJECT_MODEL:
      const supportSubjectModel = !state.supportSubjectModel;
      return {
        ...state,
        supportSubjectModel,
      }
    case actionTypes.DONATE_SUCCESS_MODEL:
      const donateSuccessModel = !state.donateSuccessModel;
      return {
        ...state,
        donateSuccessModel,
      }
    default:
      return state;
  }
}

export default reducer